<ng-container *ngIf="primaryAction">
   <ng-container *ngFor="let secondaryAction of secondaryActions; let i = index">  
      <a mat-mini-fab color="primary" *ngIf="!secondaryAction.precondition || (secondaryAction.precondition && secondaryAction.precondition())" (click)="click(secondaryAction.id)" 
         style="position: fixed; right: 28px;"
         [ngStyle]="{'bottom': (37+(50*(i+1)))+'px'}">
         <mat-icon [svgIcon]="secondaryAction.icon"></mat-icon>
      </a>
   </ng-container>
   <a mat-fab color="primary" (click)="click(primaryAction.id)" 
      style="position: fixed; right: 20px; bottom: 20px;">
      <mat-icon [svgIcon]="primaryAction.icon"></mat-icon>
   </a>
</ng-container>

